import {
    BASE_URL
  } from '../libs/tool.js'
  const baseUrl = BASE_URL +  '/smart-care/api';
  const baseURL = BASE_URL;
  const baseAPI = '/api';
  const api_auth = baseUrl + '/auth.json';

  export const addCallRecordOnCall = baseUrl + '/ccc/addCallRecordOnCall';
  export const updateCallRecordOnCallRelease = baseUrl + '/ccc/updateCallRecordOnCallRelease';
  
  export const getCallRecordListByJobId = baseUrl + '/ccc/getCallRecordListByJobId';
  export const getUserCallInfo = baseUrl + '/ccc/getUserCallInfo';
  export const getUserCallList1 = baseUrl + '/ccc/getUserCallList';

  export const saveUserCall = baseUrl + '/ccc/saveUserCall';
  export const getCallRecordList = baseUrl + '/ccc/getCallRecordList';
  export const getCallRecordDetail = baseUrl + '/ccc/getCallRecordDetail';
  export const getContactTypeList = baseUrl + '/option/getContactTypeList';
  export const getContactDispositionList = baseUrl + '/option/getContactDispositionList';
  export const getemployeeList = baseUrl + '/option/employeeList';
  
  export const editRemark = baseUrl + '/ccc/editRemark';
  export const getCallRecordByUser = baseUrl + '/ccc/getCallRecordByUser';
  
  export const pause = baseUrl + '/visit/pause';
  export const complete = baseUrl + '/visit/complete';
  export const visitAdd = baseUrl + '/visit/add';
  export const visitList = baseUrl + '/visit/list';
  export const getSimpleUserList = baseUrl + '/sys/getSimpleUserList';
  export const getCallRecordListByDate = baseUrl + '/ccc/getCallRecordListByDate';
  export const getVisitListByDate = baseUrl + '/visit/getVisitListByDate';
  export const getEmployeeListByDate = baseUrl + '/employee/getEmployeeListByDate';
  export const getCccEmployeeListByDate = baseUrl + '/sys/getCccEmployeeListByDate';
  export const agentLogin = baseUrl + '/ccc/agentLogin';
  export const agentLogout = baseUrl + '/ccc/agentLogout';
  export const statusChange = baseUrl + '/ccc/statusChange';
  export const resetAgentState = baseUrl + '/ccc/resetAgentState';
  export const getCallRecordListByAbandoned = baseUrl + '/ccc/getCallRecordListByAbandoned';
  export const getUserCallbackInfo = baseUrl + '/warning/getUserCallbackInfo';
  export const sleepBand = baseUrl + '/sleepBand/list';
  export const exportUser = baseUrl + '/user/exportUser';
  export const llimportUser = baseUrl + '/user/importUser';
  export const llimportDevice = baseUrl + '/device/importDevice';
  export const llexportDevice = baseUrl + '/device/exportDevice';
  export const importCallRecord = baseUrl + '/ccc/importCallRecord';
  export const exportCallRecord = baseUrl + '/ccc/exportCallRecord';
  export const getUserCallList = baseUrl + '/ccc/getUserCallList';
  export const getDeliverAfterSalesInfo = baseUrl + '/afterSales/getDeliverAfterSalesInfo';
  export const getAgentStatusList = baseUrl + '/yesCloudy/getAgentStatusList';
  export const getSalesPlatformList = baseUrl + '/option/getSalesPlatformList';
  export const getSignTypeList = baseUrl + '/option/getSignTypeList';
  export const cancelRelateEmployee = baseUrl + '/ccc/cancelRelateEmployee';
  export const relateEmployee = baseUrl + '/ccc/relateEmployee';
  export const relateUser = baseUrl + '/ccc/relateUser';
  export const cancelRelateUser = baseUrl + '/ccc/cancelRelateUser';
  export const customerList = baseUrl + '/option/customerList';
  export const bloodTypeList = baseUrl + '/option/bloodTypeList';
  


// WEBPACK FOOTER //
// ./src/api/apiCall.js